// global
export const g = {
	EVENT: 'EVENT',
	INCENTIVE: 'INCENTIVE',
	PARTS: 'PARTS',
	SERVICE: 'SERVICE',
	VEHICLE: 'VEHICLE'
};

// actions
export const a = {
	SET_ACCOUNT: 'SET_ACCOUNT',
	SET_PERSONALIZED: 'SET_PERSONALIZED',
	SET_HAS_DATA: 'SET_HAS_DATA',
	SET_POSITION_DATA: 'SET_POSITION_DATA',
	CLOSE_MODAL: 'CLOSE_MODAL',
	OPEN_MODAL: 'OPEN_MODAL',
	SET_LISTINGS_CAROUSEL_SLIDE_CONDITIONS:
		'SET_LISTINGS_CAROUSEL_SLIDE_CONDITIONS',
	SET_VEHICLE_ID: 'SET_VEHICLE_ID',
	SET_ACCOUNT_ID: 'SET_ACCOUNT_ID',
	SET_DESIGNS: 'SET_DESIGNS',
	SET_VARIATION_REF: 'SET_VARIATION_REF'
};

// actions
export const aR = {
	DESKTOP_10X1: 'Desktop10x1',
	DESKTOP_9x16: 'Desktop9x16',
	DESKTOP_4X1: 'Desktop4x1',
	DESKTOP_4X3: 'Desktop4x3',
	DESKTOP_9X16: 'Desktop9x16',
	MOBILE_4X3: 'Mobile4x3',
	MOBILE_4X3_SLIDESHOW: 'Mobile4x3_slideshow',
	MOBILE_4X3_COUPON: 'Mobile4x3_coupon',
	MOBILE_9X16: 'Mobile9x16'
};

export const programsApectRatios = {
	bmw: {
		desktop: {
			width: 475,
			height: 194
		},
		mobile: {
			width: 400,
			height: 163
		}
	},
	mini: {
		desktop: {
			width: 18,
			height: 7
		},
		mobile: {
			width: 3,
			height: 2
		}
	},
	// Not read directly for mazda - getProgramAspectRatio() always routes mazda
	// through getMazdaAspectRatioForVariation(), which picks between this legacy
	// ratio and the new 8G ratio based on the site's variation. Kept here as the
	// legacy value for reference/consistency with the other static programs.
	mazda: {
		desktop: {
			width: 32,
			height: 9
		},
		mobile: {
			width: 192,
			height: 179
		}
	},
	stellantis: {
		desktop: {
			width: 16,
			height: 5
		},
		mobile: {
			width: 4,
			height: 3
		}
	}
};

export const groupsWithSpecialAspectRatio = [
	{ name: 'bmw', members: ['bmwgroup'] },
	{ name: 'mini', members: ['minigroup'] },
	{ name: 'mazda', members: ['mnao'] },
	{
		name: 'stellantis',
		members: ['cllc', 'cllcpr', 'fca', 'fiat', 'alfaromeo']
	}
];

export const aspectRatios = new Map([
	['Desktop10x1', 'banner'],
	['Desktop4x1', 'slideshow'],
	['Desktop4x3', 'listing'],
	['Desktop9x16', 'vertical'],
	['Mobile4x3_slideshow', 'slideshow'],
	['Mobile4x3_coupon', 'listing'],
	['Mobile9x16', 'vertical']
]);

export const aspectRatioMapping = new Map([
	['short_horizontal_slide', 'Desktop10x1'],
	['tall_horizontal_slide', 'Desktop4x1'],
	['short_vertical_coupon', 'Desktop4x3'],
	['tall_vertical_coupon', 'Desktop9x16']
]);

export const aspectRatioMappingMobile = new Map([
	['short_vertical_slide', 'Mobile4x3_slideshow'],
	['short_vertical_coupon', 'Mobile4x3_coupon'],
	['tall_vertical_coupon', 'Mobile9x16']
]);

export const aspectRatiosModified = new Map([
	['banner', ['Desktop10x1']],
	['slideshow', ['Desktop4x1', 'Mobile4x3_slideshow']],
	['listing', ['Desktop4x3', 'Mobile4x3_coupon']],
	['vertical', ['Desktop9x16', 'Mobile9x16']]
]);

export const aspectRatiosProportions = new Map([
	['Desktop10x1', [10, 1]],
	['Desktop4x1', [4, 1]],
	['Desktop4x3', [4, 3]],
	['Mobile4x3_slideshow', [4, 3]],
	['Mobile4x3_coupon', [4, 3]],
	['Desktop9x16', [9, 16]],
	['Mobile9x16', [9, 16]]
]);

export const perpetualOptions = {
	NO_SHOW: 'NO_SHOW',
	NO_SHOW_ON_SPECIAL: 'NO_SHOW_ON_SPECIAL'
};

export const BLANK_GIF =
	'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
export const LEAD_FORM_URL = '/promotions/lead-form.htm?promotionId=';

export const DOWNSIZE_VALUES = {
	banner: {
		MOBILE: 400,
		DESKTOP: 400
	},
	slideshow: {
		MOBILE: 400,
		DESKTOP: 2000
	},
	listing: {
		MOBILE: 400,
		DESKTOP: 500
	},
	vertical: {
		MOBILE: 400,
		DESKTOP: 500
	}
};

export const UPDATED_PREF_VALUES = [
	'tall_horizontal_slide',
	'tall_vertical_coupon',
	'short_horizontal_slide',
	'short_vertical_coupon',
	'short_vertical_slide'
];
